import type { ClientMessage } from 'owa-mail-store';
import type IrmRestrictions from 'owa-mail-store/lib/store/schema/IRMRestrictions';
import getItemRightsManagementRestrictions from 'owa-mail-store/lib/utils/getItemRightsManagementRestrictions';

export function canForward(message: ClientMessage | undefined): boolean {
    const irmRestrictions: IrmRestrictions = getItemRightsManagementRestrictions(message);

    return irmRestrictions.ForwardAllowed;
}
